import styled from 'styled-components';
import { Carousel } from 'react-responsive-carousel';
import MyMap from './SingleLocationMap';
import "react-responsive-carousel/lib/styles/carousel.min.css";

let preventDefault = e => e.preventDefault();

export default function SingleLocation(props) {
  let l = props.location;

  return (
    <Wrap>
      <div className="inner">
        <Carousel className="location-carousel" showStatus={false} showThumbs={false}>
          { l.images.map(img => <div key={img.large}><img src={img.large} draggable={false} onDragStart={preventDefault} /></div>) }
        </Carousel>
        <Body>
          <Back onClick={() => props.setLocation(null)}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={22}
            height={22}
            viewBox="0 0 22 22"
          >
            <circle
              className="color"
              cx={11}
              cy={11}
              r={10}
              fill="none"
              stroke="#9999a5"
            />
            <g transform="translate(0.5, 0.5)">
              <path
                className="color"
                fill="none"
                stroke="#9999a5"
                strokeWidth="2px"
                strokeLinecap="round"
                d="M11.885 14.553L7.832 10.5M11.885 6.447L7.832 10.5"
              />
            </g>
          </svg>
          Sve lokacije</Back>

          <h1>{ l.name }</h1>
          <div className="info">
            <div className="info-item">
              <div>Grad</div>
              <div>{ l.city_name }</div>
            </div>

            <div className="info-item">
              <div>Rezolucija</div>
              <div>{ l.screen_width }x{ l.screen_height }px</div>
            </div>

            <div className="info-item">
              <div>Trajanje</div>
              <div>{ l.ad_duration } sekundi</div>
            </div>

            <div className="info-item">
              <div>Tip</div>
              <div>{ l.motion_type || 'Full motion' }</div>
            </div>
          </div>

          <div className="map">
            <MyMap location={l.location} />
          </div>
        </Body>
      </div>
    </Wrap>
  );
}

let Wrap = styled.div`
  background: white;
  height: 100%;

  .inner {
    max-width: 1000px;
    margin: 0 auto;
    position: relative;
  }

  .location-carousel {
    width: 100%;

    .slide img {
      user-select: none;
    }

    .carousel.carousel-slider .control-arrow {
      width: 60px;
    }
  }

  @media (min-width: 1000px) {
    padding-top: 25px;
  }
`;

let Body = styled.div`
  max-width: 1000px;
  margin: 0 auto;
  padding-top: 20px;

  h1 {
    font-size: 30px;
    color: #6c6c7a;
    font-weight: 300;
  }

  .info {
    margin-top: 25px;
    flex-wrap: wrap;
    display: flex;

    @media (min-width: 700px) {
      flex-wrap: nowrap;
    }
  }

  .info-item {
    margin-top: 10px;

    @media (min-width: 700px) {
      margin-top: 0;
      margin-right: 60px;
    }
  }

  .info-item > div:first-child {
    text-transform: uppercase;
    font-weight: bold;
    font-size: 12px;
    margin-bottom: 5px;
  }

  .info-item > div:last-child {
    font-weight: 300;
    font-size: 1.2em;
    color: #6c6c7a;
  }

  @media (max-width: 699px) {
    .info-item {
      width: 50%;
    }
  }

  .map {
    margin-top: 30px;
    width: 100%;
    height: 300px;
  }

  @media (max-width: 1000px) {
    h1, .info {
      padding: 0 25px;
    }
  }
`;

let Back = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
  color: #9999A5;
  text-decoration: none;
  height: 20px;
  margin-bottom: 20px;
  font-size: 16px;
  width: 160px;

  svg {
    margin-right: 10px;
  }

  .color {
    stroke: #9999A5;
  }

  &:hover, &:active  {
    color: #0CD459;
  }

  &:hover .color, &:active .color {
    stroke: #0CD459;
  }

  @media (max-width: 1000px) {
    margin-left: 25px;
  }
`;

